import { useTags } from 'features/tags';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useExistingFilterTags = () => {
  const user = useUser();
  const tags = useTags();

  return useMemo(
    () =>
      user?.settings?.allTasks?.filterByTags?.filter((tagId) =>
        tags.find(({ id }) => id === tagId),
      ) ?? [],
    [tags, user?.settings?.allTasks?.filterByTags],
  );
};
